import { LINK_PREVIEW_TYPE, LinkPreviewViewer } from 'wix-rich-content-plugin-link-preview/viewer';
export const typeMapper = ()=>({
        [LINK_PREVIEW_TYPE]: {
            component: LinkPreviewViewer,
            classNameStrategies: {
                container: (theme)=>theme['linkPreviewContainer'],
                custom: (componentData, theme, styles, isMobile)=>theme['linkPreviewPlugin']
            }
        }
    });
